<template>
  <div>
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="">
            <h4
              class="text-left mt-4 d-flex d-sm-none text-black bold"
              style="font-size: 24px"
            >
              Create a Quiz
            </h4>
            <div class="mt-4 custom-font text-center" style="font-size: 15px">
              These are the form for creating a quiz. Please fill up the form
              and submit to proceed.
            </div>

           <CRow>
              <div
                class="mx-auto d-flex justify-content-center col-12 ml-4 mt-1"
              >
                <div class="text-center">
                  <CRow class="justify-content-center">
                    <CCol sm="12" lg="12">
                      <CCol>
                        <h6
                          class="
                            text-left
                            d-flex d-sm-none
                            text-black
                            bold
                            mt-4
                            custom-font
                          "
                        >
                          <strong>Quiz Title</strong>
                        </h6>
                      </CCol>
                      <CCol>
                        <CTextarea
                          v-model="Question"
                          class="mt-2"
                          placeholder="Enter Your Question Title"
                          vertical
                          rows="3"
                        />
                      </CCol>
                    </CCol>

                    <CCol sm="12" lg="12" class="mt-1">
                      <CCol>
                        <h6
                          class="
                            text-left
                            d-flex d-sm-none
                            text-black
                            bold
                            custom-font
                          "
                        >
                          <strong>
                          Subject
                          </strong>
                        </h6>
                      </CCol>
                      <CCol>
                        <v-select
                          class="mt-2"
                          v-model="SelectedSubject"
                          :options="subjects"
                          style="width: 100%; position: relative; z-index: auto"
                          label="SubjectName"
                          placeholder="Please Select Subject"
                          required
                        ></v-select>
                      </CCol>
                    </CCol>

                    <CCol sm="12" lg="12" class="mt-4">
                      <CCol>
                        <h6
                          class="
                            text-left
                            d-flex d-sm-none
                            text-black
                            bold
                            custom-font
                          "
                        >
                          <strong> Grade</strong>
                        </h6>
                      </CCol>
                      <CCol>
                        <v-select
                          class="mt-2"
                          v-model="SelectedGrade"
                          :options="grades"
                          style="width: 100%; position: relative; z-index: auto"
                          label="GradeName"
                          placeholder="Please Select Grade"
                          required
                          prepend-icon="cli-clock"
                        >
                        </v-select>
                      </CCol>
                    </CCol>

                    <CCol sm="12" lg="12" class="mt-4 text-left">
                      <label style="text-align:left" class="text-danger text-left">Note: Please input duration with complete format</label>
                      <CCol>
                         <h6
                          class="
                            text-left
                            d-flex d-sm-none
                            text-black
                            bold
                            custom-font
                          "
                        >
                          <strong>
                          Time</strong>
                        </h6>
                      </CCol>
                      <CCol class="mt-2">
                        <v-timepicker
                          v-model="SelectedTimer"
                          :options="timer"
                          format="HH:mm:ss"
                          :minute-interval="5"
                          placeholder="Please Insert Duration"
                          >
                        </v-timepicker>

                        
                      </CCol>
                    </CCol>
                  </CRow>
                  <br />
                  <CCol>
                    <div v-if="SubmittedForm === true">
                      <h5>We will list partner for you.Wait a moment ......</h5>
                      <br />
                      <CButton color="success" size="lg" block disabled
                        >Submitted</CButton
                      >
                    </div>
                    <div v-else>
                      <CButton
                        color="success"
                        class="custom-btn mt-4"
                        size="lg"
                        block
                        @click="CreateQuizTitle"
                        >Submit</CButton
                      >
                    </div>
                    <br />
                    <br />
                    <br />
                  </CCol>
                </div>
              </div>
            </CRow> 

          
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
  },
  data() {
    return {
      backgroundBanner,
      subjects: [],
      grades: [],
      SelectedSubject: "",
      SelectedGrade: "",
      Question: "",
      SelectedTimer: "",
      SubmittedForm: false,
      Error: false,
    };
  },
  async mounted() {
    this.GetSubject();
    this.GetGrade();
  },
  computed: {
    isDisabled: function () {
      return !this.SelectedSubject.Id || !this.SelectedGrade.Id;
    },
  },
  methods: {
    async GetSubject() {
      this.$API
        .get(this.$QuizSubjectList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$QuizGradeList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    CreateQuizTitle() {
      this.SubmittedForm = true;
      if (
        this.SelectedSubject.Id === "" &&
        this.SelectedGrade.Id === "" &&
        this.Question === ""
      ) {
        this.Error = true;
      } else {
        this.Error = false;
        const formData = new FormData();

        formData.append("userId", this.$route.query.userId);
        formData.append("title", this.Question);
        formData.append("subjectId", this.SelectedSubject.Id);
        formData.append("gradeId", this.SelectedGrade.Id);
        formData.append("Timer", this.SelectedTimer);

        return this.$API
          .post(this.$CreateQuizTitle, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              var quizTitleId = response.data;
              this.GoToPageCreateQuestion(quizTitleId);
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.status);
              console.log(error.response.data);
            }
          });
      }
    },
    GoToPageCreateQuestion(quizTitleIds) {
      console.log("masuk");
      console.log(quizTitleIds);
      this.$router.push(
        "/QuizTeacherCreateQuestion?quizTitleId=" +
          quizTitleIds +
          "&userId=" +
          this.$route.query.userId
      );
    },
  },
};
</script>

<style>
/* .vue__time-picker input.display-time {
  border: transparent;
  width: 30em;
  height: 3em;
  font-size: 1em;
} */

.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 100%;
  font-family: sans-serif;
  vertical-align: middle;
  border: 1px solid;
  color: #768192;
  background-color: #fff;
  border-color: #d8dbe0;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.vue__time-picker input.display-time {
  border: transparent;
  /* width: 30em; */
  height: 3em;
  font-size: 1em;
  width: 100% !important;
}
.vue__time-picker-dropdown, .vue__time-picker .dropdown {
    position: absolute;
    z-index: 5;
    top: calc(2.2em + 2px);
    left: 0;
    background: #fff;
    -webkit-box-shadow: 0 1px 6px rgb(0 0 0 / 15%);
    box-shadow: 0 1px 6px rgb(0 0 0 / 15%);
    width: 100% !important;
    height: 10em;
    font-weight: 400;
}
.vue__time-picker-dropdown .select-list, .vue__time-picker .dropdown .select-list {
    width: 100% !important;
    height: 10em;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

#fb-root{
  display:none;
}
</style>